import { Skeleton } from '@mantine/core';

/**
 * Generic fallback skeleton for dashboard components without a custom .Skeleton.
 *
 * Used by DashboardGrid's Suspense boundaries when a component doesn't define
 * its own skeleton via the createGridComponent() helper.
 */
export function BoxSkeleton() {
  return <Skeleton animate height="100%" radius="md" width="100%" />;
}
